module.exports = __webpack_public_path__ + "img/terracenew_box10.3b99671a.jpg";